import { Navigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { BloqMark } from "@/components/brand/BloqLogo";

export default function ProtectedRoute({ children }) {
  const { token, loading } = useAuth();

  if (loading) {
    return (
      <div className="flex h-screen w-full items-center justify-center bg-bloq-bg">
        <BloqMark size={54} animate />
      </div>
    );
  }

  if (!token) return <Navigate to="/login" replace />;

  return children;
}
